export default function HeroSection() {
  const navigate = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/booking');
    }
  };

  const navigateToShops = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/nearby-shops');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/494f4b28d88172926527673dc0cec812.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 py-32 w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-light text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            다움 BEAUTY
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-12 leading-relaxed">
            네일·뷰티 예약을 한 번에, 더 예쁘게 더 편하게
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <button 
              onClick={navigate}
              className="px-8 py-4 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-base font-medium rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              지금 예약하기
            </button>
            <button 
              onClick={navigateToShops}
              className="px-8 py-4 bg-white/95 backdrop-blur-sm text-rose-400 text-base font-medium rounded-full hover:bg-white hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
            >
              주변 뷰티샵 찾기
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center animate-bounce">
          <span className="text-white/80 text-sm mb-2">Scroll</span>
          <i className="ri-arrow-down-line text-white/80 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
